import { render, staticRenderFns } from "./GGanttTimeaxis.vue?vue&type=template&id=18608364&scoped=true"
import script from "./GGanttTimeaxis.vue?vue&type=script&lang=js"
export * from "./GGanttTimeaxis.vue?vue&type=script&lang=js"
import style0 from "./GGanttTimeaxis.vue?vue&type=style&index=0&id=18608364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18608364",
  null
  
)

export default component.exports